import instance from 'services/api';
import { toast } from 'react-toastify';
import {
  GET_PROMOTIONS_POS,
  ADD_PROMOTION_POS,
  UPDATE_PROMOTION_POS,
  DELETE_PROMOTION_POS,
  SET_LOADING_POS,
} from 'redux/actions/types';

const getPromoId = (p) => p?.uuid || p?._uuid || p?.promotionDetail?.uuid || p?._id;

// The gateway nests the service's reason one level down; anything else means
// the call never reached it.
const toastError = (err) => {
  const message = err?.response?.data?.message;
  toast.error(message?.message || message || '');
};

export const getPromotionsPOS = (businessUuid) => (dispatch) => {
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .get(`/cloud-pos/promotion/promotions`, {
      params: { businessUuid },
    })
    .then((response) => {
      const data = response?.data?.data;
      dispatch({ type: GET_PROMOTIONS_POS, payload: data });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      return Promise.reject(err);
    });
};

export const createPromotionPOS = (body) => (dispatch, getState) => {
  const promotions = getState().pos.promotions;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .post(`/cloud-pos/promotion/promotions`, body)
    .then((response) => {
      const data = response?.data?.data;
      dispatch({ type: ADD_PROMOTION_POS, payload: [...promotions, data] });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      toastError(err);
      return Promise.reject(err);
    });
};

export const updatePromotionPOS = (dataReq) => (dispatch, getState) => {
  const promotions = getState().pos.promotions;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .patch(`/cloud-pos/promotion/promotions/${dataReq.id}`, dataReq.body)
    .then((response) => {
      const data = response?.data?.data;
      const updated = promotions.map((p) =>
        getPromoId(p) === dataReq.id ? data : p
      );
      dispatch({ type: UPDATE_PROMOTION_POS, payload: updated });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return data;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      toastError(err);
      return Promise.reject(err);
    });
};

export const deletePromotionPOS = (id, businessUuid) => (dispatch, getState) => {
  const promotions = getState().pos.promotions;
  dispatch({ type: SET_LOADING_POS, payload: true });
  return instance
    .delete(`/cloud-pos/promotion/promotions/${id}`)
    .then(() => {
      const filtered = promotions.filter((p) => getPromoId(p) !== id);
      dispatch({ type: DELETE_PROMOTION_POS, payload: filtered });
      dispatch({ type: SET_LOADING_POS, payload: false });
      return filtered;
    })
    .catch((err) => {
      dispatch({ type: SET_LOADING_POS, payload: false });
      return Promise.reject(err);
    });
};
